import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export function useNavigationBlocker(enabled: boolean) {
	const router = useRouter();

	useEffect(() => {
		if (!enabled) return;

		const unblock = router.history.block({
			blockerFn: () => {
				const confirmed = window.confirm("Are you sure you want to leave this page?");
				return !confirmed; // true = block, false = allow
			},
		});

		return unblock;
	}, [router, enabled]);
}
